import React, { useEffect, useRef, createContext, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { completeSsoCallback } from '@/utilities/ssoClient';

import { UserContext } from '@/components/App';

export const Context = createContext();

export const ContextProvider = ({ children }) => {
    const navigate = useNavigate();
    const { type } = useParams();
    const { user } = useContext(UserContext);

    const [error, setError] = useState(null);
    const [inflight, setInflight] = useState(true);
    const claimed = useRef(false);

    useEffect(() => {
        // The code is single use, so StrictMode's second invocation would redeem a spent one.
        if (claimed.current) {
            return;
        }
        claimed.current = true;

        const handleCallback = async () => {
            try {
                await completeSsoCallback(type);

                setInflight(false);
                navigate('/account');
            } catch (err) {
                console.error('SSO callback error:', err);
                setInflight(false);
                setError(err.message || 'An error occurred during SSO sign-in.');
            }
        };

        if (user) {
            navigate('/account');
        } else {
            handleCallback();
        }
    }, [navigate, type, user]);

    return (
        <Context.Provider
            value={{
                state: {},
                loading: {
                    init: inflight,
                },
                callbacks: {},
                errors: {
                    auth: error,
                },
            }}
        >
            {children}
        </Context.Provider>
    );
};
